// src/firebase.js
// Configuración de Firebase y Analytics para React
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAr5EC5C5dOTcjRyCyJi3-ISs2eOt6wkmc",
  authDomain: "planiaro.firebaseapp.com",
  projectId: "planiaro",
  storageBucket: "planiaro.firebasestorage.app",
  messagingSenderId: "463730324055",
  appId: "1:463730324055:web:340f5676568384b1bc6912",
  measurementId: "G-546Y6RFCZ6"
};


const app = initializeApp(firebaseConfig);
let analytics;

// Do not initialize analytics automatically. Export a function to init when consent is given.
export function initAnalytics() {
  if (typeof window === 'undefined') return null;
  // Never track local development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return null;
  if (analytics) return analytics;
  try {
    analytics = getAnalytics(app);
    return analytics;
  } catch (e) {
    return null;
  }
}

// Return the analytics instance if it was already initialized, but do NOT initialize it.
export function getAnalyticsInstance() {
  return analytics;
}

export { /*logEvent*/ };
